import { useState, type FormEvent } from "react";
import { useAuth } from "../auth";
import { useRouter, Link } from "../router";
import { BrandMark } from "../components/BrandMark";

export function Login() {
  const { login } = useAuth();
  const { navigate } = useRouter();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const res = await login(username, password);
    setSubmitting(false);
    if (res.ok) navigate("/app/crm");
    else setError(res.error);
  }

  return (
    <div className="login">
      <Link to="/" className="login-back">
        ← Back to Andersen
      </Link>
      <div className="login-card">
        <div className="login-brand">
          <BrandMark size={36} />
          <span>Andersen</span>
        </div>
        <h1 className="login-title">Sign in</h1>
        <p className="login-sub">Wealth Management — demo environment</p>

        <form onSubmit={onSubmit} className="login-form" noValidate>
          <label className="field">
            <span>Username</span>
            <input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              required
            />
          </label>
          <label className="field">
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          {error && <div className="login-error">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary login-submit"
            disabled={submitting}
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
